module.exports = __webpack_public_path__ + "images/emoji/u6708.618bc3857640ad405521.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u6708.png
// module id = njDC
// module chunks = 13